var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { MUTATIONS } from '../store/mobileMenuModule';
var MobileSideNav = /** @class */ (function (_super) {
    __extends(MobileSideNav, _super);
    function MobileSideNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sidebar = null;
        _this.toggleButton = null;
        return _this;
    }
    Object.defineProperty(MobileSideNav.prototype, "isMobileMenuOpen", {
        get: function () {
            return this.$store.state.mobileMenu.isOpen;
        },
        enumerable: false,
        configurable: true
    });
    MobileSideNav.prototype.toggleMenu = function () {
        this.$store.commit(MUTATIONS.TOGGLE_MOBILE_MENU);
        if (this.isMobileMenuOpen) {
            document.addEventListener('keydown', this.handleKeyDown);
            setTimeout(function () {
                var sidebarH1 = document.querySelector('.main-sidebarnav h1');
                if (sidebarH1) {
                    sidebarH1.setAttribute('tabindex', '-1');
                    sidebarH1.focus();
                }
            }, 100);
        }
        else {
            document.removeEventListener('keydown', this.handleKeyDown);
        }
    };
    MobileSideNav.prototype.handleKeyDown = function (event) {
        var _a, _b;
        if (!this.isMobileMenuOpen)
            return;
        if (event.key === 'Escape') {
            this.toggleMenu();
        }
        // Define all focusable element selectors.
        var focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        var sidebar = document.querySelector('.main-sidebarnav'); // Get the sidebar element.
        var focusableElements = sidebar === null || sidebar === void 0 ? void 0 : sidebar.querySelectorAll(focusableSelectors);
        var firstFocusableElement = focusableElements.length > 0 ? focusableElements[0] : null;
        var lastFocusableElement = focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
        // Act only on Tab key presses.
        if (event.key !== 'Tab')
            return;
        if (event.shiftKey && document.activeElement === firstFocusableElement) {
            event.preventDefault();
            (_a = this.toggleButton) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
            event.preventDefault();
            (_b = this.toggleButton) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else if (document.activeElement === this.$refs.toggleButton && !event.shiftKey) {
            event.preventDefault();
            firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
        }
    };
    MobileSideNav.prototype.mounted = function () {
        var _this = this;
        this.toggleButton = this.$refs.toggleButton;
        this.$watch('$route', function () {
            if (_this.isMobileMenuOpen) {
                _this.$store.commit(MUTATIONS.SET_MOBILE_MENU_OPEN, false);
            }
        });
    };
    MobileSideNav = __decorate([
        Component
    ], MobileSideNav);
    return MobileSideNav;
}(Vue));
export default MobileSideNav;
